/* eslint-disable jsx-a11y/no-autofocus */
/* eslint-disable no-plusplus */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/forbid-prop-types */
import React, { useState, useRef, useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useMutation, useQuery } from 'react-query';
import PropTypes from 'prop-types';
import { isMobile } from 'react-device-detect';
import ModalBodyLayout from '../../../shared/ModalBodyLayout';
import { useRate } from '../../../../utilities/sharedHooks/rates';
import { exchange, currencies } from '../../../../utilities/constants';
import {
  SETTINGS_SUPPORTED_CURRENCIES_QUERY_KEY,
  USER_PREFERENCES,
} from '../../../../utilities/sharedQueries';
import { showAlert } from '../../../../utilities/notifications';
import {
  formatDecimalNumber,
  formatNumber,
  formatNumberWithComma,
  addDecimalToNumber,
  formatCryptoAmountOnBlur,
} from '../../../../utilities/formatHelpers';

import { NETWORK_FEES_TYPES, AMOUNT_INPUT_MAX_LENGTH, WalletScreens } from '../../constants';
import Badge from '../../../../components/Badge';

import { useLedgerFilteredCurrencies } from '../../../../utilities/sharedHooks/ledgerWallets';
import { GenericLoading } from '../../../../components/Placeholders';
import CurrencyIcon from '../../../../components/CurrencyIcon';
import FocusableInputArea from '../../partials/FocusableInputArea';
import { useCurrency, useSetting } from '../../../../utilities/sharedHooks/settings';
import useIsUsUser from '../../../../utilities/sharedHooks/usUser';

import { validateNumbers } from '../../../../utilities/formValidation';
import {
  WalletsTypes,
  cardOrderFeesKeys,
  UK_COUNTRY,
  mainCardTypes,
} from '../../../Card/constants';
import { useUserPersonalInfo } from '../../../../utilities/sharedHooks/user';
import { BUY_FIAT } from '../../mutations';
import { useLedgerTransaction } from '../../../../utilities/sharedHooks/ledgerSDKHooks';
import completeLedgerFund from './completeLedgerFund';

const LedgerWalletDeposit = ({
  options,
  openScreen,
  withBack,
  onPrevClick,
  updateForm,
  optionsForm,
}) => {
  const { t: translate } = useTranslation();
  const { data: userPreferences } = useQuery(USER_PREFERENCES);
  const wallet = options ? options?.wallet : null;
  const ledgerAccount = options ? options?.ledgerAccount : null;

  const { displayCurrency } = userPreferences || {};
  const rate = useRate(wallet?.coin, displayCurrency, true);
  const [fiatInputWidth, setFiatInputWidth] = useState(0);
  const [cryptoInputWidth, setCryptoInputWidth] = useState(0);
  const [payCrypto, setPayCrypto] = useState(true);
  const [isSwap, setIsSwap] = useState(false);
  const fiatInputSpan = useRef();
  const cryptoInputSpan = useRef();

  const isWithBackBtn = withBack || options?.withBackBtn;

  const { countryDisplayName } = useUserPersonalInfo();

  const [selectedBadge, setSelectedBadge] = useState(null);

  const currency = useCurrency(wallet?.coin?.toLowerCase());

  const textInputRef = useRef(null);

  const isUsUser = useIsUsUser();

  const [feauterPgwAllowed] = useSetting('app_features', 'feature_pgw_allowed');

  const { data: supportedCurrencies } = useLedgerFilteredCurrencies([
    SETTINGS_SUPPORTED_CURRENCIES_QUERY_KEY,
  ]);
  const isAllowBuyPGW = useMemo(() => {
    if (supportedCurrencies && wallet?.coin) {
      return supportedCurrencies[wallet?.coin]
        ? supportedCurrencies[wallet?.coin].allows_buy_pgw
        : false;
    }
    return false;
  }, [supportedCurrencies, wallet?.coin]);

  const cardOrderFeeKey = useMemo(() => {
    let key = '';
    if (optionsForm && optionsForm?.mainCardType === mainCardTypes.PHYSICAL) {
      if (isUsUser) {
        key = cardOrderFeesKeys.US;
      } else if (countryDisplayName === UK_COUNTRY) {
        key = cardOrderFeesKeys.UK;
      } else {
        key = cardOrderFeesKeys.EU;
      }
    } else {
      key = cardOrderFeesKeys.ROW;
    }

    return key;
  }, [isUsUser, countryDisplayName, optionsForm]);

  const [cardOrderFee] = useSetting('server_configurations', cardOrderFeeKey);
  const payCardFundCurrencies = useSetting('server_configurations', 'stable_coin_can_fund_by_card');
  const [orderCardFreeLimitBalance] = useSetting('server_configurations', 'promo_amount_free_card');
  const [orderCardFreeLimitBalanceCurrency] = useSetting(
    'server_configurations',
    'promo_amount_free_card_currency'
  );
  const cardOrderFeeForDisplay = useMemo(() => {
    const cardOrderFeeValue = cardOrderFee / 100;
    const coinCurrency = optionsForm?.cardCurrency?.coin || displayCurrency;
    return `${currencies[coinCurrency].symbol}${cardOrderFeeValue}`;
  }, [cardOrderFee, optionsForm?.cardCurrency?.coin]);

  const [form, setForm] = useState({
    fiat: '0.00',
    crypto: '0',
    amount: 0,
    fee: '',
  });
  const [isManualAmount, setIsManualAmount] = useState(false);

  const { sendTransaction, isLoading: isLoadingTransaction } = useLedgerTransaction(
    wallet,
    currency
  );

  const { mutate: buyFiat, isLoading: isLoadingBuyFiat } = useMutation(BUY_FIAT, {
    onSettled: (data) => {
      if (typeof data === 'string') {
        showAlert({ message: data, type: 'danger' });
      } else {
        openScreen(WalletScreens.RECEIVE_DETAILS, { ...options, pgwUrl: data.redirectUrl });
      }
    },
  });
  // TODO: below two useEffects must be refactored
  useEffect(() => {
    if (fiatInputSpan.current) {
      const charactersLength =
        fiatInputSpan.current.value.length > 1 ? fiatInputSpan.current.value.length : 1;
      // to avoid having empty input, fix length to 1 if text length is less then 1
      setFiatInputWidth(charactersLength);
    }
  }, [form.fiat]);

  useEffect(() => {
    if (cryptoInputSpan.current) {
      const closestContainer = cryptoInputSpan.current.closest('.d-flex');
      const closestContainerParent = closestContainer.closest('.modal-body');
      const charactersLength =
        cryptoInputSpan.current.value.length > 1 ? cryptoInputSpan.current.value.length : 2;
      // to avoid having empty input, fix length to 2 if text length is less then 1
      if (closestContainerParent.offsetWidth < closestContainer.scrollWidth) {
        closestContainer.style.fontSize = '1.5rem';
      } else if (cryptoInputSpan.current.value.length < AMOUNT_INPUT_MAX_LENGTH) {
        // resize input font size to 2.125rem when char length is less then AMOUNT_INPUT_MAX_LENGTH
        closestContainer.style.fontSize = '2.125rem';
      }
      setCryptoInputWidth(charactersLength);
    }
  }, [form.crypto]);

  const [networkFeeType, setNetworkFeeType] = useState(NETWORK_FEES_TYPES.Medium);

  const isLoading = isLoadingTransaction;

  if (isLoading) {
    return <GenericLoading />;
  }

  const PREDEFINED_AMOUNTS = [500, 1500, 2000, 5000];

  const handleChangeFiat = (e) => {
    const { value, min } = e.target;

    const { decimalAmount, formattedAmount } = formatDecimalNumber(value.toString(), min);

    if (!validateNumbers(decimalAmount, WalletsTypes.FIAT)) {
      return;
    }

    if (!decimalAmount || !formattedAmount) {
      setForm({
        ...form,
        amount: 0,
        fiat: '0.00',
        crypto: '0',
      });
    }

    const calcCrypto = formatNumber(decimalAmount / rate, exchange.CRYPTO_VALUE);
    const formattedCalcCrypto = formatDecimalNumber(calcCrypto);

    setForm({
      ...form,
      amount: Number(
        parseFloat(formattedCalcCrypto.decimalAmount).toFixed(currency.currency_exponent)
      ),
      fiat: formattedAmount,
      crypto: calcCrypto === Infinity ? '-' : formattedCalcCrypto.formattedAmount,
    });
  };

  const handleChangeCrypto = (e) => {
    const { value, min } = e.target;

    const { decimalAmount, formattedAmount } = formatDecimalNumber(value.toString(), min);

    if (!validateNumbers(decimalAmount, WalletsTypes.CRYPTO)) {
      return;
    }

    if (!decimalAmount || !formattedAmount) {
      setForm({
        ...form,
        amount: 0,
        fiat: '0.00',
        crypto: '0',
      });
    }

    const calcFiat = formatNumber(decimalAmount * rate, exchange.FIAT_VALUE);
    const formattedFiatCalc = formatDecimalNumber(calcFiat);

    setForm({
      ...form,
      amount: Number(parseFloat(decimalAmount).toFixed(currency.currency_exponent)),
      crypto: formattedAmount,
      fiat: formattedFiatCalc.formattedAmount,
    });
  };

  const handleFiatFocus = (e) => {
    if (!e.target) return;
    e.target.select();
  };

  const handleFocus = (e) => {
    if (!e.target) return;
    if (e.target.closest('.amount-input')) {
      e.target.closest('.amount-input').classList.add('active');
    }
    if (e.target.name === 'fee') {
      textInputRef.current.style.display = 'inline-block';
    }
  };

  const handleBlur = (e) => {
    if (!e.target) return;
    if (e.target.closest('.amount-input')) {
      e.target.closest('.amount-input').classList.remove('active');
    }
    if (e.target.name === 'fee' && e.target.value.trim() === '') {
      textInputRef.current.style.display = 'none';
    }

    const decimalNumber = formatCryptoAmountOnBlur(e?.target?.value);
    if (decimalNumber) {
      setForm({
        ...form,
        crypto: decimalNumber.valueWithDecimal,
      });
      // to avoid having empty input, fix length to 1 if text length is less then 1
      setCryptoInputWidth(decimalNumber.charactersLength);
    }
  };

  const handleSelectBadge = (amount) => {
    setIsManualAmount(false);
    setSelectedBadge(selectedBadge !== amount ? amount : null);
    if (selectedBadge !== amount) {
      handleChangeFiat({ target: { value: amount, min: 0 } });
    } else {
      setForm({
        ...form,
        fiat: '0.00',
        crypto: '0',
      });
    }
  };

  const onSubmitTransaction = async () => {
    const { success } = await sendTransaction(form.amount, networkFeeType, ledgerAccount?.address);
    if (optionsForm) {
      optionsForm.paymentMethodType = WalletsTypes.CRYPTO;
      updateForm(optionsForm);
    }
    completeLedgerFund({
      success,
      openScreen,
      screenOptions: { ...options, ledgerAccount, wallet },
      translate,
    });
  };

  const renderTitle = () => (
    <b className="text-f5 text-dark me-auto">
      <CurrencyIcon
        currencyCode={wallet?.coin}
        className="me-2"
        style={{
          width: '1.6rem',
          height: '1.6rem',
          ...(wallet?.coin?.toUpperCase() === currencies.XRP.icon
            ? {
                backgroundColor: 'white',
                padding: '1px',
                borderRadius: '20px',
              }
            : {}),
        }}
      />
      {translate('card_order_top_up_wallet_title').replace('%s', wallet?.coin.toUpperCase())}
    </b>
  );

  const payWithCardHandler = () => {
    if (form.fiat) {
      let valueWithDecimal = form.amount || '';
      const decimalNumber = addDecimalToNumber(valueWithDecimal);
      if (decimalNumber) {
        valueWithDecimal = decimalNumber.valueWithDecimal;
      }
      buyFiat({
        amount: valueWithDecimal,
        coin: displayCurrency?.toLowerCase(),
        currency: wallet?.coin,
      });
    } else {
      showAlert({ message: translate('payment_card_empty_amount'), type: 'danger' });
    }
  };

  const renderFooter = () => {
    if (payCrypto) {
      return (
        <>
          {options && options?.isCardOrderFlow && (
            <div className="w-100 mt-4 p-0 mb-3">
              <div className="alert alert-info d-flex align-items-center" role="alert">
                <div>
                  <i className="icon icon-info-icon position-relative top-0" />
                </div>
                <span className="content">{translate('add_funds_flow_alert')}</span>
              </div>
            </div>
          )}

          {!process.env.REACT_APP_FLAVOR && options && !options?.isCardOrderFlow && (
            <div className="w-100 mt-4 p-0 mb-3">
              <div className="alert alert-info d-flex align-items-center" role="alert">
                <div>
                  <i className="icon icon-info-icon position-relative top-0" />
                </div>
                <span className="content">{translate('receive_with_ledger_note')}</span>
              </div>
            </div>
          )}

          {!process.env.REACT_APP_FLAVOR && (
            <button
              loading={isLoading ? 'true' : 'false'}
              type="button"
              disabled={!(ledgerAccount && form?.amount > 0)}
              className={`btn ${
                !(ledgerAccount && form?.amount > 0) ? 'btn-disabled' : 'btn-primary'
              } py-3`}
              onClick={onSubmitTransaction}>
              {translate('continue_with_ledger_btn_label')}
            </button>
          )}

          <button
            type="button"
            className="btn rounded-4 bg-transparent p-3 border border-disabled text-center mt-4"
            tabIndex={-1}
            onClick={() => openScreen(WalletScreens.RECEIVE, { ...options })}
            onKeyDown={null}>
            {translate('receive_from_external_address_label')}
          </button>
        </>
      );
    }

    return (
      <>
        <button
          type="button"
          className="btn btn-primary py-3 mt-4"
          tabIndex={-1}
          loading={isLoadingBuyFiat ? 'true' : 'false'}
          disabled={isLoadingBuyFiat}
          onClick={payWithCardHandler}
          onKeyDown={null}>
          {translate('confirm_continue_btn_title')}
        </button>
      </>
    );
  };

  const showPredefinedAmountBudges = options && !options?.isOrderCardFlow;

  return (
    <ModalBodyLayout
      withBack={!!isWithBackBtn}
      isScrollable={isMobile}
      onPrevClick={
        options?.withBackBtn ? () => openScreen(options?.prevScreen, { ...options }) : onPrevClick
      }
      renderTitle={renderTitle}
      renderFooter={renderFooter}>
      {options && options?.isOrderCardFlow && (
        <div className="pt-4">
          <p>
            {translate('top_up_balance_free_card_1')}{' '}
            <span className="bg-attention-info d-inline-block text-center rounded-2 py-0 px-1">
              {currencies[orderCardFreeLimitBalanceCurrency].symbol}
              {formatNumber(orderCardFreeLimitBalance, exchange.FIAT_VALUE)}
            </span>
          </p>
          <p>
            {translate('top_up_balance_free_card_2')}{' '}
            <span className="text-bold">{cardOrderFeeForDisplay}</span>{' '}
            {translate('top_up_balance_free_card_3')}
          </p>
          <p className="text-f6 text-shadow w-85 mt-1">{translate('top_up_balance_free_card_4')}</p>
        </div>
      )}
      <div className="d-flex flex-column h-100">
        {payCardFundCurrencies[0].split(',').includes(wallet?.coin.toLocaleLowerCase()) && (
          <div
            className={`col-12 rounded pb-1 pt-2 ${
              options && options?.isOrderCardFlow ? '' : 'mt-4'
            }`}>
            <div className="btn-light w-100 d-flex flex-row-center bg-lighter border border-disable rounded-4">
              <button
                type="button"
                className={`toggle-item text-white p-1 btn toggle-item-modal w-50 toggle-item rounded-3 ${
                  payCrypto && 'active'
                }`}
                onClick={() => setPayCrypto(true)}>
                {translate('crypto_payment')}
              </button>
              <button
                type="button"
                className={`toggle-item text-white p-1 btn w-50 toggle-item-modal toggle-item rounded-3 ${
                  !payCrypto && 'active'
                }`}
                disabled={!isAllowBuyPGW || !feauterPgwAllowed}
                onClick={() => setPayCrypto(false)}>
                {translate('payment_card')}
              </button>
            </div>
          </div>
        )}
        {!(options && options?.isOrderCardFlow) && (
          <p className="text-shadow text-f6 text-start pt-4 mt-4">
            {translate('deposit_wallet_enter_amount')}
          </p>
        )}
        <div
          className="text-center d-flex align-items-center"
          style={{ flex: options && options?.isOrderCardFlow ? '' : 1 }}>
          <div className="w-100 h-100">
            <FocusableInputArea className="">
              <input
                required
                min="0"
                type="text"
                className="form-control bg-transparent p-0 text-center border-0"
                name="fiat"
                value={isSwap ? form.crypto : form.fiat}
                style={{
                  width: `${(isSwap ? cryptoInputWidth : fiatInputWidth) + 1}ch`,
                  height: '1.5rem',
                }}
                ref={isSwap ? cryptoInputSpan : fiatInputSpan}
                onChange={(e) => {
                  if (isSwap) {
                    handleChangeCrypto(e);
                  } else {
                    handleChangeFiat(e);
                  }
                  setIsManualAmount(true);
                }}
                onFocus={handleFiatFocus}
                disabled
                placeholder="0 "
              />
              <span style={{ fontSize: 'inherit', pointerEvents: 'none' }} className="text-f5">
                {isSwap ? wallet?.coin.toUpperCase() : displayCurrency}
              </span>
              <span
                role="button"
                className="mb-1"
                tabIndex="0"
                onKeyPress={() => setIsSwap((a) => !a)}
                onClick={() => setIsSwap((a) => !a)}>
                <img src="./assets/images/switch.svg" className="ms-2" alt="switch" />
              </span>
            </FocusableInputArea>
            <FocusableInputArea className="h1 amount-input">
              <input
                required
                autoFocus
                min="0"
                type="text"
                className="form-control bg-transparent text-bold p-0 text-center border-0"
                value={isSwap ? form.fiat : form.crypto}
                style={{
                  fontSize: 'inherit',
                  width: `${(isSwap ? fiatInputWidth : cryptoInputWidth) + 1}ch`,
                  color: 'inherit',
                  height: 'inherit',
                }}
                ref={isSwap ? fiatInputSpan : cryptoInputSpan}
                onChange={(e) => {
                  if (isSwap) {
                    handleChangeFiat(e);
                  } else {
                    handleChangeCrypto(e);
                  }
                  setIsManualAmount(true);
                }}
                onFocus={handleFocus}
                onBlur={!isSwap ? handleBlur : () => {}}
                placeholder="0  "
              />
              <b
                style={{
                  fontSize: 'inherit',
                  pointerEvents: 'none',
                  color: 'inherit',
                }}>
                {isSwap ? displayCurrency : wallet?.coin.toUpperCase()}
              </b>
            </FocusableInputArea>
            {showPredefinedAmountBudges && (
              <div className="d-flex justify-content-between mt-3">
                {PREDEFINED_AMOUNTS.map((amount) => (
                  <Badge
                    notifyRemoveActive={isManualAmount}
                    key={amount}
                    content={`${formatNumberWithComma(amount)} ${displayCurrency.toUpperCase()}`}
                    onClick={() => {
                      handleSelectBadge(amount);
                    }}
                    className={`${
                      selectedBadge === amount ? 'active' : ''
                    } p-1 text-white rounded-3 text-f5 cursor-pointer bg-lighter border border-disabled`}
                    style={{ width: '5rem' }}
                  />
                ))}
              </div>
            )}
            {payCrypto && (
              <>
                <p className="text-shadow text-f6 text-start pt-4 mt-4 pb-3">
                  {translate('deposit_wallet_select_fees')}
                </p>
                <div className="flex-row-center bg-lighter border border-disabled rounded-4">
                  <span
                    style={{ height: '2rem' }}
                    className={`btn btn-sm toggle-item toggle-item-modal ${
                      networkFeeType === NETWORK_FEES_TYPES.Slow && 'active'
                    } flex-fill p-1 small-badge`}
                    onClick={() => setNetworkFeeType(NETWORK_FEES_TYPES.Slow)}
                    onKeyDown={() => setNetworkFeeType(NETWORK_FEES_TYPES.Slow)}
                    role="button"
                    tabIndex={-1}>
                    {translate('deposit_wallet_low')}
                  </span>
                  <span
                    style={{ height: '2rem', lineHeight: '2rem' }}
                    className={`btn btn-sm toggle-item toggle-item-modal ${
                      networkFeeType === NETWORK_FEES_TYPES.Medium && 'active'
                    } flex-fill px-1 py-0 small-badge`}
                    onClick={() => setNetworkFeeType(NETWORK_FEES_TYPES.Medium)}
                    onKeyDown={() => setNetworkFeeType(NETWORK_FEES_TYPES.Medium)}
                    role="button"
                    tabIndex={-1}>
                    {translate('deposit_wallet_standard')}
                  </span>
                  <span
                    style={{ height: '2rem' }}
                    className={`btn btn-sm toggle-item toggle-item-modal ${
                      networkFeeType === NETWORK_FEES_TYPES.Fast && 'active'
                    } flex-fill p-1 small-badge`}
                    onClick={() => setNetworkFeeType(NETWORK_FEES_TYPES.Fast)}
                    onKeyDown={() => setNetworkFeeType(NETWORK_FEES_TYPES.Fast)}
                    role="button"
                    tabIndex={-1}>
                    {translate('deposit_wallet_high')}
                  </span>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </ModalBodyLayout>
  );
};

export default LedgerWalletDeposit;

LedgerWalletDeposit.propTypes = {
  openScreen: PropTypes.func.isRequired,
  options: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  withBack: PropTypes.bool,
  onPrevClick: PropTypes.func,
  optionsForm: PropTypes.object,
  updateForm: PropTypes.func,
};

LedgerWalletDeposit.defaultProps = {
  options: null,
  withBack: null,
  optionsForm: null,
  onPrevClick: () => {},
  updateForm: () => {},
};
